import { render, staticRenderFns } from "./PrintRecords.vue?vue&type=template&id=5a714fc0&scoped=true&"
import script from "./PrintRecords.vue?vue&type=script&lang=ts&"
export * from "./PrintRecords.vue?vue&type=script&lang=ts&"
import style0 from "./PrintRecords.vue?vue&type=style&index=0&id=5a714fc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a714fc0",
  null
  
)

export default component.exports